import {
  ApplicationConfig,
  LOCALE_ID,
  importProvidersFrom,
  // isDevMode,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { httpInterceptor } from './interceptor-http.service';
// import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideStore } from '@ngrx/store';
import { provideRouterStore } from '@ngrx/router-store';
import { provideEffects } from '@ngrx/effects';

import { provideGoogleService } from '@ls-commons/auth';
import { utilsCacheInterceptor } from '@ls-commons/utils/interceptors';
import { environment } from '../environments/environment';
import { MessageService } from 'primeng/api';
import { ComponentsConfigModule } from '@ls-commons/components/config';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEn from '@angular/common/locales/en';
import localeDe from '@angular/common/locales/de';
import localeCa from '@angular/common/locales/ca';
import localeFr from '@angular/common/locales/fr';
import localePt from '@angular/common/locales/pt';

registerLocaleData(localeEs, 'es');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeCa, 'ca');
registerLocaleData(localeDe, 'de');
registerLocaleData(localeFr, 'fr');
registerLocaleData(localePt, 'pt');

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(ComponentsConfigModule),
    MessageService,
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
      })
    ),
    provideAnimations(),
    provideHttpClient(
      withInterceptors([httpInterceptor(), utilsCacheInterceptor()])
    ),
    provideStore(),
    provideEffects(),
    provideRouterStore(),
    provideGoogleService(environment.GOOGLE_ID),
    // provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    {
      provide: LOCALE_ID,
      useValue: document.documentElement.lang,
    },
  ],
};
